import React from "react";

interface QuestionMarkIconProps {
    size?: number;
    color?: string;
}

const QuestionMarkIcon: React.FC<QuestionMarkIconProps> = ({ size = 14, color = "#003366" }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.99996 12.8337C10.2083 12.8337 12.8333 10.2087 12.8333 7.00033C12.8333 3.79199 10.2083 1.16699 6.99996 1.16699C3.79163 1.16699 1.16663 3.79199 1.16663 7.00033C1.16663 10.2087 3.79163 12.8337 6.99996 12.8337Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5.25 5.54253C5.25 5.54253 5.27625 4.94097 5.86141 4.45863C6.20885 4.17225 6.62612 4.0893 7 4.0842C7.34143 4.08001 7.64659 4.13779 7.82906 4.22675C8.14096 4.37951 8.75 4.75139 8.75 5.54253C8.75 6.37506 8.21807 6.7524 7.61341 7.16821C7.00875 7.58402 6.85417 7.9918 6.85417 8.4592" stroke={color} strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round"/>
            <path d="M6.85421 10.4274C7.17637 10.4274 7.43754 10.1662 7.43754 9.84408C7.43754 9.52191 7.17637 9.26074 6.85421 9.26074C6.53204 9.26074 6.27087 9.52191 6.27087 9.84408C6.27087 10.1662 6.53204 10.4274 6.85421 10.4274Z" fill={color}/>
        </svg>
    );
};

export default QuestionMarkIcon;
